import { SidebarMenu } from "../react-app-env";

export const sidebarMenus = [
	{ label: 'Dashboard', path: '/' },
	{ label: 'Data Barang', path: '/data-barang' },
	{ label: 'Jadwal Loading', path: '/jadwal-loading' },
	{ label: 'Data Admin', path: '/data-admin' },
	{ label: 'Pengaturan Akun', path: '/pengaturan-akun' },
] as SidebarMenu[];

export const inventoryCategoriesMenu = [
	{ label: 'Semua Kategori', id: "all" },
	{ label: "Panstop", id: "671ce723cd0f9e470d9a745f" },
	{ label: "Piring", id: "671ce730cd0f9e470d9a7462" },
	{ label: "Aksesoris", id: "671ce733cd0f9e470d9a7465" },
	{ label: "Pondokan", id: "671ce735cd0f9e470d9a7468" },
	{ label: "Dekorasi", id: "671ce73bcd0f9e470d9a746b" },
	{ label: "Bowl", id: "671ce73dcd0f9e470d9a746e" },
	{ label: "Kain", id: "671ce745cd0f9e470d9a7471" },
	{ label: "Sendok", id: "671cf3acf60c73d2bf1759f7" },
	{ label: "Meja", id: "67209cc702198d00e99283cf" },
	{ label: "Seragam", id: "676144d6e94df606ef602a5d" },
]

export const transactionsPath = [
	{
		label: 'Income',
		path: '/transactions/income',
	},
	{
		label: 'Outcome',
		path: '/transactions/outcome',
	},
] as SidebarMenu[];

export const performancePath = [
	{
		label: 'Mesin Giling',
		path: '/performance/machine',
	},
	{
		label: 'Penyortir',
		path: '/performance/sorter',
	},
] as SidebarMenu[];
